import { render, staticRenderFns } from "./domestic.vue?vue&type=template&id=3d8e8ae2&scoped=true&"
import script from "./domestic.vue?vue&type=script&lang=js&"
export * from "./domestic.vue?vue&type=script&lang=js&"
import style0 from "./domestic.vue?vue&type=style&index=0&id=3d8e8ae2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8e8ae2",
  null
  
)

export default component.exports